import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

type NavListProps = {
	children: React.ReactNode;
	bordered?: boolean;
	className?: string;
	gap?: 'sm' | 'default';
};

const NavList = ({ children, bordered = true, className, gap = 'default' }: NavListProps) => {
	return (
		<ul
			className={twMerge(
				clsx(
					'flex flex-col',
					gap === 'default' ? 'gap-5' : 'gap-2',
					bordered && 'border-l border-secondary pl-2',
				),
				className,
			)}
		>
			{children}
		</ul>
	);
};

export default NavList;
